import { SubtenantTokensState } from './types';

export const DEFAULT_SUBTENANTS_TOKENS_STATE: SubtenantTokensState = {
  tokens: {},
  tenantIds: [],
};
